import script from "./Object1View.vue?vue&type=script&setup=true&lang=js"
export * from "./Object1View.vue?vue&type=script&setup=true&lang=js"

import "./Object1View.vue?vue&type=style&index=0&id=a6d8de56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d8de56"]])

export default __exports__